module.exports = __webpack_public_path__ + "static/media/anson.bd3e39f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/anson.png
// module id = 1149
// module chunks = 0